// 在线评估-待评估
<template>
  <div class="est-box-main" v-if="isRefresh">
    <div class="sub-top-line">
      <!-- <el-button type="primary" size="medium" class="btn-icon-36 btn-icon-1ab394" icon="el-icon-plus" @click="addProject"></el-button> -->
      <!-- <el-button type="primary" size="medium" class="btn-icon-36 btn-icon-23c6c8" icon="el-icon-user" @click="presetNextPer"></el-button> -->
      <!-- <el-button type="primary" size="medium" class="btn-icon-36 btn-icon-23c6c8" icon="el-icon-s-order" @click="addDep"></el-button> -->
      <!-- <el-button type="primary" size="medium" class="btn-icon-36 btn-icon-ed5565" icon="el-icon-delete" @click="deleteMany"></el-button> -->
      <el-button size="medium" class="btn-icon-36" icon="el-icon-refresh-right" @click="handleRefresh"></el-button>
    </div>
    <div class="mainTable">
      <table class="listTable" width="100%" border="1" align="center">
        <tr>
          <th class="cell thtitle" width="4%">序号</th>
          <!-- <th class="cell thtitle" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th> -->
          <th class="cell thtitle" v-for="(th, thi) in tableNamesS" :key="thi">{{th}}</th>
          <th class="cell thtitle" width="12%">操作</th>
        </tr>
        <tr v-for="(tr, tri) in tabDataCrt.tableData" :key="tri">
          <td class="cell tdcell">{{(pageNo - 1) * pages + tri + 1}}</td>
          <!-- <td class="cell tdcell" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi"> -->
          <td class="cell tdcell" v-for="(td, tdi) in rowItemsS" :key="tdi">
            <el-input v-if="tr.editFlag" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
          <td class="cell tdcell">
            <el-button class="text-btn" type="text" size="mini" @click="showDetails(tr)">主表详情</el-button><br>
            <el-button class="text-btn" type="text" size="mini" @click="inspectionRecord(tr)">检查记录</el-button><br>
            <el-button class="text-btn" type="text" size="mini" @click="showProtectionCheck(tr)">保护目标</el-button><br>
            <el-button class="text-btn" type="text" size="mini" @click="add2(tr)">上传会议通知</el-button><br>
            <el-button class="text-btn" type="text" size="mini" @click="showProSitTable(tr)">项目情况表</el-button>
            <el-button class="text-btn" type="text" size="mini" @click="showLogger(tr)">进度</el-button><br>
            <!-- <el-button class="text-btn" type="text" size="mini" @click="deleteRow(tr)">删除</el-button><br> -->
          </td>
        </tr>
      </table>
    </div>
    <div class="pro-sit-box" v-if="showProSitFormFlag">
      <proSitForm @closeForm="closeProSitForm" :category="pageCategory" :eiaStatusId="eiaStatusId"></proSitForm>
    </div>
    <!-- other -->
    <div class="bottom-pagination">
      <el-pagination
        hide-on-single-page
        small
        background
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :page-size="pages"
        :current-page="pageNo"
        :total="totalNumber">
      </el-pagination>
    </div>
    <nut-dialog
      @close="showDetailsDialogFlag = false"
      v-if="showDetailsDialogFlag"
      :visible="showDetailsDialogFlag"
      title="详情"
      :noFooter="true">
      <div class="details-dialog-main">
        <table>
          <template v-for="(title, tindex) in tableNamesD">
            <tr :key="tindex*2">
              <th>{{ title }}</th>
            </tr>
            <tr :key="tindex*2+1">
              <td>{{ detailsRow[rowItemsD[tindex]] }}</td>
            </tr>
          </template>
        </table>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showLoggerFlag = false"
      v-if="showLoggerFlag"
      :visible="showLoggerFlag"
      title="操作进度"
      :noFooter="true">
      <div class="logger-dialog-main">
        <table>
          <tr v-for="(activity, index) in activities" :key="index">
            <td>
              <p class="text-time">{{ activity.timestamp }}</p>
              <p class="text-main">{{ activity.operator }}</p>
              <p class="text-main">{{ activity.operationType }}</p>
              <p class="text-main">{{ activity.operationDetails }}</p>
              <p class="text-main">{{ activity.operationOpinion }}</p>
            </td>
          </tr>
        </table>
      </div>
      <div class="bottom-pagination">
        <el-pagination
          hide-on-single-page
          small
          background
          layout="prev, pager, next, jumper"
          @current-change="handleCurrentChangeL"
          :page-size="pagesL"
          :current-page="currentPageL"
          :total="totalNumberL">
        </el-pagination>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="handleClose"
      v-if="showAddPrjFormFlag"
      :visible="showAddPrjFormFlag"
      title="新增项目"
      :noFooter="true">
      <div class="prosit-main-box">
        <div class="prosit-main-scroll-box">
          <div class="line-input line-textarea">
            <span class="label-4">项目名称</span>
            <el-input class="input-s4" type="textarea" v-model="projectInfo.entryName"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-4">委托部门</span>
            <select class="input-s4" v-model="projectInfo.department">
              <option v-for="item in departmentList1" :key="item.key" :label="item.label" :value="item.label"></option>
            </select>
            <!-- <el-input class="input-s4d2" v-model="projectInfo.department" placeholder="可填写其他部门"></el-input> -->
          </div>
          <div class="line-input line-single">
            <span class="label-4"></span>
            <el-input class="input-s4" v-model="projectInfo.department" placeholder="可填写选项里没有的部门"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-4">所在区域</span>
            <select class="input-s4" v-model="projectInfo.projectTeamPersonnel" @change="citySearch(projectInfo.projectTeamPersonnel)">
              <option v-for="item in provinceList" :key="item.value" :label="item.pro" :value="item.pro"></option>
            </select>
          </div>
          <div class="line-input line-single">
            <span class="label-4"></span>
            <select class="input-s4" v-model="projectInfo.projectChecker">
              <option v-for="item in cityList" :key="item.value" :label="item.city || item.area" :value="item.city || item.area"></option>
            </select>
          </div>
          <div class="line-input line-single">
            <span class="label-4"></span>
            <el-input class="input-s4" v-model="projectInfo.area"></el-input>
          </div>
          <div class="line-input line-single">
            <span class="label-4">文件类型</span>
            <select class="input-s4" v-model="projectInfo.fileType">
              <option label="报告书" value="报告书"></option>
              <option label="报告表" value="报告表"></option>
              <option label="登记表" value="登记表"></option>
              <option label="危废许可证" value="危废许可证"></option>
            </select>
          </div>
          <div class="line-input line-filelist">
            <span class="label-6">上传环评报告</span>
            <el-button class="input-s6d2 center-btn btn-text" type="primary" @click="add1">选择文件</el-button>
          </div>
          <div class="line-input line-filelist">
            <span class="label-6">上传其他材料</span>
            <el-button class="input-s6d2 center-btn btn-text" type="primary" @click="add2">选择文件</el-button>
          </div>
          <div class="line-input line-button">
            <el-button class="btn-icon-36 center-btn img-icon-save" icon="el-icon-minus" type="primary" @click="addInvestigation"></el-button>
          </div>
        </div>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showAddDepFlag"
      v-if="showAddDepFlag"
      :visible="showAddDepFlag"
      title="预设委托部门"
      :noFooter="true">
      <div class="prosit-main-box">
        <div class="prosit-main-scroll-box">
          <div class="line-input line-textarea">
            <span class="label-full">请输入需要预设的委托部门，以中文逗号相隔，如“部门A，部门B，部门C”</span>
          </div>
          <div class="line-input line-textarea">
            <el-input class="input-full" type="textarea" v-model="addDepValue"></el-input>
          </div>
          <div class="line-input line-button">
            <el-button class="input-s4d2 center-btn btn-text" type="primary" @click="doAddDep(addDepValue)">确定</el-button>
          </div>
        </div>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="upFlag = false"
      v-if="upFlag"
      :visible="upFlag"
      title="上传材料"
      :noFooter="true">
      <div class="prosit-main-box">
        <div class="prosit-main-scroll-box">
          <div class="line-input line-filelist">
            <span class="label-6">上传环评报告</span>
            <el-button class="input-s6d2 center-btn btn-text" type="primary" @click="add1">选择文件</el-button>
          </div>
          <div class="line-input line-filelist">
            <span class="label-6">上传其他材料</span>
            <el-button class="input-s6d2 center-btn btn-text" type="primary" @click="add2">选择文件</el-button>
          </div>
        </div>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showReportFlag = false"
      v-if="showReportFlag"
      :visible="showReportFlag"
      title="上传环评报告"
      :noFooter="true">
      <uploadBaseEst
        ref="uploadRef1"
        :btnName="'上传'"
        :uploadMethod="'cdEiaStatusUpload'"
        :acceptList="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf'"
        :extaParam="extaParamA"
        :fileSize="100"
        @uploadSuccess="handleSuccessA"
        @beforeUpload="checkUploadA">
      </uploadBaseEst>
    </nut-dialog>
    <nut-dialog
      @close="upOtherFileFlag = false"
      v-if="upOtherFileFlag"
      :visible="upOtherFileFlag"
      title="上传会议通知"
      :noFooter="true">
      <upOtherFile type='待评估' :eiaStatusId="eiaStatusId"></upOtherFile>
    </nut-dialog>
    <nut-dialog
      @close="jindu = false"
      v-if="jindu"
      :visible="jindu"
      title="下载进度"
      :noFooter="true">
      <progress :value="percentage" max="100"></progress>{{ percentage }}%
      <p>{{ text1 }}</p>
    </nut-dialog>
    <nut-dialog
      @close="showProtectionCheckDialogFlag = false"
      v-if="showProtectionCheckDialogFlag"
      :visible="showProtectionCheckDialogFlag"
      title="保护目标"
      height="1000px"
      :noFooter="true">
      <div class="protection-dialog-main-estMeeNotice">
        <div class="pd-left">
          <protection-map ref="protectionMap" :protectionCenter="protectionCenter"></protection-map>
        </div>
        <div class="pd-right">
          <table>
            <tr>
              <th v-for="(cell, sindex) in protectionTable.title" :key="sindex">{{ cell }}</th>
            </tr>
            <tr v-for="(line, index) in protectionTable.table" :key="index">
              <td v-for="(cell, sindex) in line" :key="sindex" align="center">{{ cell }}</td>
            </tr>
          </table>
        </div>
      </div>
    </nut-dialog>
  </div>
</template>

<script>
import api from '../../../api/indexForCoe'
import proSitForm from './proSitForm.vue'
import uploadBaseEst from './uploadBaseEst.vue'
import upOtherFile from './upOtherFile.vue'
import protectionMap from '../protectionMap'
export default {
  data () {
    return {
      phone: sessionStorage.getItem('qs_phone'),
      pageCategory: '待评估',
      pageRouter: '/estOverview',
      tabType: 'tabA',
      companyName: '',
      // tabData
      tabData: [
        {
          tabTitle: '在线评估-待评估',
          tabIndex: 'tabA',
          tabType: 'table',
          tableNames: [
            '项目名称',
            '委托部门',
            '所在区域',
            '文件类型'
          ],
          rowItems: [
            'entryName',
            'department',
            'area',
            'fileType'
          ],
          api: {
            add: 'cdEiaStatusAdd',
            enquiry: 'cdEiaStatusEnquiry',
            update: 'cdEiaStatusUpdate',
            delete: 'cdEiaStatusDelete',
            extraParam: {
              phone: sessionStorage.getItem('qs_phone'),
              type: '待评估'
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        }
      ],
      tabDataCrt: {},
      tableNamesS: [
        '项目名称',
        // '委托部门',
        // '所在区域',
        '文件类型'
      ],
      rowItemsS: [
        'entryName',
        // 'department',
        // 'area',
        'fileType'
      ],
      tableNamesD: [
        '项目名称',
        '委托部门',
        '所在区域',
        '文件类型'
      ],
      rowItemsD: [
        'entryName',
        'department',
        'area',
        'fileType'
      ],
      pages: 10,
      pageNo: 1,
      totalNumber: 1,
      isRefresh: true,
      // jindu: false,
      // percentage: 10,
      // text1: '',
      // importFlag: false,
      extaParam: {},
      wordInfo: false,
      detailsRow: {},
      showDetailsDialogFlag: false,
      showLoggerFlag: false,
      activities: [],
      pagesL: 5,
      currentPageL: 1,
      totalNumberL: 0,
      showProSitFormFlag: false,
      eiaStatusId: 0,
      upFlag: false,
      showReportFlag: false,
      upOtherFileFlag: false,
      // eia
      projectInfo: {
        entryName: '',
        constructionParty: '',
        area: '',
        constructionSite: '',
        approvalDepartment: '',
        fileType: '',
        evaluationScope: '',
        projectProcess: '',
        projectContact: '',
        contactNumber: '',
        projectUndertaker: '',
        preparationHost: '',
        projectOrganizer: '',
        projectCreator: '',
        staffing: '',
        projectTeamPersonnel: '浙江省',
        projectChecker: '',
        projectPreliminaryReviewer: '',
        projectStatus: '',
        department: '',
        creationTime: '',
        contractStatus: ''
      },
      provinceList: [],
      cityList: [],
      departmentList1: [],
      showAddPrjFormFlag: false,
      showAddDepFlag: false,
      addDepValue: '',
      // meeNotice
      jindu: false,
      percentage: 10,
      text1: '',
      importFlag: false,
      showProtectionCheckDialogFlag: false,
      protectionCenter: '',
      protectionTable: {
        title: ['title1', 'title2', 'title3', 'title4', 'title5'],
        table: [
          ['cell1', 'cell2', 'cell3', 'cell4', 'cell5'],
          ['cell1', 'cell2', 'cell3', 'cell4', 'cell5'],
          ['cell1', 'cell2', 'cell3', 'cell4', 'cell5'],
          ['cell1', 'cell2', 'cell3', 'cell4', 'cell5']
        ]
      }
    }
  },
  computed: {
    extaParamA () {
      return {
        type: '待评估',
        phone: this.phone,
        id: this.eiaStatusId
      }
    }
  },
  mounted () {
    this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
    this.getTabData()
    // eia
    api.reportReferenceProvince({
      type: 1,
      pid: 0
    }).then(res => {
      this.provinceList = res.data
    })
  },
  methods: {
    getTabData (pageNo = 1) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.enquiry]({
          pageNo: pageNo,
          pages: 10,
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.totalNumber = res.data.totalNumber
          var tempArr = []
          res.data.list.forEach(item => {
            var arrPusher = {
              id: item.id,
              jsonData: item.jsonData,
              longitude: item.longitude,
              latitude: item.latitude,
              editFlag: false
            }
            this.tabDataCrt.rowItems.forEach(rowItem => {
              arrPusher[rowItem] = item[rowItem] || ''
            })
            tempArr.push(arrPusher)
          })
          this.tabDataCrt.tableData = tempArr
          console.log(this.tabDataCrt.tableData)
        })
      } else if (this.tabDataCrt.tabType === 'multiform') {
      }
    },
    handleRefresh () {
      this.getTabData()
    },
    table_index (index) {
      return (this.pageNo - 1) * this.pages + index + 1
    },
    handleCurrentChange (pageNo) {
      this.pageNo = pageNo
      this.getTabData(this.pageNo)
    },
    // closeIF () {
    //   this.importFlag = false
    // },
    // addRow () {
    //   this.importFlag = true
    // },
    // handleSuccess () {
    //   this.$toast.text('上传成功')
    //   this.getTabData()
    // },
    // checkUpload () {
    //   this.$refs.uploadRef.doUpload()
    // },
    // closeWI () {
    //   this.wordInfo = false
    // },
    // addTerm () {
    //   this.wordInfo = true
    // },
    // editRow (row) {
    //   // row.editFlag = true
    //   this.percentage = 0
    //   this.jindu = true
    //   var bianliang = setInterval(() => {
    //     this.percentage = this.percentage + 1
    //     if (this.percentage >= 99) {
    //       clearInterval(bianliang)
    //     }
    //   }, 1000)
    //   api.cdSummaryTableDownload({
    //     id: row.id
    //   }).then(res => {
    //     console.log(res)
    //     if (res.code === 200) {
    //       window.open(res.data)
    //       this.percentage = 100
    //       clearInterval(bianliang)
    //       setTimeout(() => {
    //         this.jindu = false
    //       }, 1000)
    //     } else {
    //       clearInterval(bianliang)
    //       this.text1 = res.message
    //     }
    //     // if (res.code === 40001) {
    //     //   this.jindu = false
    //     // }
    //   })
    // },
    // saveRow (row) {
    //   if (this.tabDataCrt.tabType === 'table') {
    //     var savePusher = {
    //       id: row.id,
    //       ...this.tabDataCrt.api.extraParam
    //     }
    //     this.tabDataCrt.rowItems.forEach(rowItem => {
    //       console.log(row, rowItem, row[rowItem])
    //       savePusher[rowItem] = row[rowItem] || ''
    //     })
    //     api[this.tabDataCrt.api.update](savePusher).then(res => {
    //       console.log(res)
    //       this.$nextTick(() => {
    //         this.isRefresh = true
    //         this.pageNo = 1
    //         this.getTabData()
    //       })
    //     })
    //   }
    // },
    showDetails (row) {
      console.log(row)
      this.detailsRow = row
      this.showDetailsDialogFlag = true
    },
    showLogger (row) {
      console.log(row)
      this.detailsRow = row
      this.showLoggerFlag = true
      this.getJournalt(1)
    },
    getJournalt (pageNo = 1) {
      api.cdEiaJournalEnquiry({
        pages: 5,
        pageNo: pageNo,
        superiorId: this.detailsRow.id
      }).then(res => {
        console.log(res)
        this.totalNumberL = res.data.totalNumber
        var centerArr = []
        if (res.data.totalNumber !== 0) {
          res.data.list.forEach(item => {
            centerArr.push({
              operator: item.operator,
              operationType: item.operationType,
              timestamp: item.operationTime,
              operationDetails: item.operationDetails,
              operationOpinion: item.operationOpinion
            })
            this.activities = centerArr
          })
        } else if (res.data.totalNumber === 0) {
          this.activities = []
        }
        // this.activities.reverse()
      })
    },
    handleCurrentChangeL (currentPage) {
      this.currentPageL = currentPage
      this.getJournalt(this.currentPageL)
    },
    showProSitTable (row) {
      this.eiaStatusId = row.id
      this.showProSitFormFlag = true
    },
    closeProSitForm (changePath) {
      this.showProSitFormFlag = false
      if (changePath) {
        this.$emit('doChangePath', changePath)
      }
    },
    // add1 () {
    //   this.showReportFlag = true
    // },
    // add2 () {
    //   this.upOtherFileFlag = true
    // },
    // add3 (row) {
    //   this.eiaStatusId = row.id
    //   this.upFlag = true
    // },
    add2 (row) {
      this.eiaStatusId = row.id
      this.upOtherFileFlag = true
    },
    // eia
    citySearch (id) {
      if (id !== '') {
        api.reportReferenceProvince({
          type: 1,
          pid: id
        }).then(res => {
          this.cityList = res.dataF
        })
      }
    },
    addProject () {
      this.projectInfo = {
        entryName: '',
        constructionParty: '',
        area: '',
        constructionSite: '',
        approvalDepartment: '',
        fileType: '',
        evaluationScope: '',
        projectProcess: '',
        projectContact: '',
        contactNumber: '',
        projectUndertaker: '',
        preparationHost: '',
        projectOrganizer: '',
        projectCreator: '',
        staffing: '',
        projectTeamPersonnel: '浙江省',
        projectChecker: '',
        projectPreliminaryReviewer: '',
        projectStatus: '',
        department: '',
        creationTime: '',
        contractStatus: ''
      }
      api.reportReferenceProvince({
        type: 1,
        pid: '浙江省'
      }).then(res => {
        this.cityList = res.dataF
      })
      api.companyNameByEnquiry({
        phoneOne: this.phone
      }).then(res => {
        this.departmentList1 = []
        var departments1 = res.data.split('，')
        for (var i = 0; i < departments1.length; i++) {
          this.departmentList1.push({
            key: i,
            value: '选项' + i,
            label: departments1[i]
          })
        }
      })
      api.cdEiaStatusAdd({
        phone: this.phone,
        type: '待评估',
        entryName: this.projectInfo.entryName,
        constructionParty: this.projectInfo.constructionParty,
        area: this.projectInfo.area,
        constructionSite: this.projectInfo.constructionSite,
        approvalDepartment: this.projectInfo.approvalDepartment,
        fileType: this.projectInfo.fileType,
        evaluationScope: this.projectInfo.evaluationScope,
        projectProcess: this.projectInfo.projectProcess,
        projectContact: this.projectInfo.projectContact,
        contactNumber: this.projectInfo.contactNumber,
        projectUndertaker: this.projectInfo.projectUndertaker,
        preparationHost: this.projectInfo.preparationHost,
        projectOrganizer: this.projectInfo.projectOrganizer,
        projectCreator: this.projectInfo.projectCreator,
        staffing: this.projectInfo.staffing,
        projectTeamPersonnel: this.projectInfo.projectTeamPersonnel,
        projectChecker: this.projectInfo.projectChecker,
        projectPreliminaryReviewer: this.projectInfo.projectPreliminaryReviewer,
        projectStatus: this.projectInfo.projectStatus,
        department: this.projectInfo.department,
        creationTime: this.projectInfo.creationTime,
        contractStatus: '已签'
      }).then(res => {
        console.log(res)
        this.eiaStatusId = res.data.id
        this.$nextTick(function () {
          this.getTabData(this.pageNo)
        })
        this.showAddPrjFormFlag = true
      })
    },
    handleClose () {
      this.showAddPrjFormFlag = false
      api.cdEiaStatusDelete({
        id: this.eiaStatusId,
        type: '删除'
      }).then(res => {
        console.log(res)
        this.getTabData(this.pageNo)
      })
    },
    // showReportUpload (row) {
    //   this.eiaStatusId = row.order
    //   this.upOtherFileFlag = true
    // },
    addDep () {
      this.showAddDepFlag = true
    },
    doAddDep (value) {
      if (!value) {
        this.$toast.text('请输入需要预设的委托部门，以中文逗号相隔，如部门A，部门B，部门C')
        return
      }
      // let departments = value.split('，')
      console.log(value)
      api.companyNameUpdate({
        departmentList: value,
        phone: this.phone
      }).then(res => {
        this.$toast.text(res.message)
        if (res.code === 200) {
          this.showAddDepFlag = false
        }
      })
      // this.reload()
    },
    deleteRow (row) {
      var deleteRow = confirm('确定要删除该项目吗？')
      if (deleteRow) {
        api.cdEiaStatusDelete({
          id: row.id
        }).then(res => {
          console.log(res)
          this.$nextTick(function () {
            this.getTabData(this.pageNo)
          })
        })
      }
    },
    addInvestigation () {
      api.cdEiaStatusUpdate({
        id: this.eiaStatusId,
        entryName: this.projectInfo.entryName,
        constructionParty: this.projectInfo.constructionParty,
        area: this.projectInfo.area,
        constructionSite: this.projectInfo.constructionSite,
        approvalDepartment: this.projectInfo.approvalDepartment,
        fileType: this.projectInfo.fileType,
        evaluationScope: this.projectInfo.evaluationScope,
        projectProcess: this.projectInfo.projectProcess,
        projectContact: this.projectInfo.projectContact,
        contactNumber: this.projectInfo.contactNumber,
        projectUndertaker: this.projectInfo.projectUndertaker,
        preparationHost: this.projectInfo.preparationHost,
        projectOrganizer: this.projectInfo.projectOrganizer,
        projectCreator: this.projectInfo.projectCreator,
        staffing: this.projectInfo.staffing,
        projectTeamPersonnel: this.projectInfo.projectTeamPersonnel,
        projectChecker: this.projectInfo.projectChecker,
        projectPreliminaryReviewer: this.projectInfo.projectPreliminaryReviewer,
        projectStatus: this.projectInfo.projectStatus,
        department: this.projectInfo.department,
        creationTime: this.projectInfo.creationTime,
        contractStatus: this.projectInfo.contractStatus
      }).then(res => {
        console.log(res)
        this.$nextTick(function () {
          this.getTabData(this.pageNo)
        })
        this.showAddPrjFormFlag = false
        this.projectInfo = {}
      })
    },
    handleSuccessA () {
      this.$toast.text('上传成功')
      api.cdEiaStatusEnquiry({
        phone: this.phone,
        pages: 10,
        pageNo: 1,
        type: '待评估'
      }).then(res => {
        console.log(res)
        this.projectInfo = {
          entryName: res.data.list[0].entryName,
          department: res.data.list[0].department,
          projectTeamPersonnel: res.data.list[0].projectTeamPersonnel,
          projectChecker: res.data.list[0].projectChecker,
          area: res.data.list[0].area,
          fileType: res.data.list[0].fileType
        }
        api.reportReferenceProvince({
          type: 1,
          pid: res.data.list[0].projectTeamPersonnel
        }).then(res => {
          this.cityList = res.dataF
        })
        this.getTabData()
      })
    },
    checkUploadA () {
      this.$refs.uploadRef1.doUpload()
    },
    // meenotice
    inspectionRecord (row) {
      // row.editFlag = true
      this.text1 = ''
      this.percentage = 0
      this.jindu = true
      var bianliang = setInterval(() => {
        this.percentage = this.percentage + 1
        if (this.percentage >= 99) {
          clearInterval(bianliang)
        }
      }, 1000)
      api.cdEiaStatusDownload({
        id: row.id
      }).then(res => {
        console.log(res)
        if (res.code === 200) {
          window.open(res.data)
          this.percentage = 100
          clearInterval(bianliang)
          setTimeout(() => {
            this.jindu = false
          }, 1000)
        } else {
          clearInterval(bianliang)
          this.text1 = res.message
        }
        // if (res.code === 40001) {
        //   this.jindu = false
        // }
      })
    },
    showProtectionCheck (row) {
      console.log(row)
      if (row.jsonData) {
        this.showProtectionCheckDialogFlag = true
        this.protectionCenter = [Number(row.longitude), Number(row.latitude)]
        this.protectionTable = JSON.parse(row.jsonData)
        setTimeout(() => {
          this.$refs.protectionMap.addGraphics()
        }, 3000)
      } else {
        this.$toast.text('该项目没有保护目标')
      }
    }
  },
  components: {
    upOtherFile,
    uploadBaseEst,
    proSitForm,
    protectionMap
    // eiaTableImport,
    // protectionMap
    // api,
    // showTableData () {
    //   return this.tableData
    // }
  }
}
</script>

<style lang="scss">
.est-box-main{
  z-index: 0;
  height: 100%;
  overflow-y: auto;
  .sub-top-line {
    height: 36px;
    padding: 10px 0 0 0;
  }
  .mainTable{
    margin: 10px;
    width: calc(100% - 20px);
    word-break: break-all;
    .tableFileCell{
      text-decoration: underline;
      color: #00C;
    }
    .tableFileCell:hover{
      color: #66F;
      text-decoration: none;
    }
    .cell{
      border: 1px #ccc solid;
      text-align: center;
    }
    .thtitle{
      background-color: #fafafa;
      line-height: 24px;
    }
    .tdcell{
      background-color: #fff;
      line-height: 32px;
      padding: 2px;
      .el-input__inner{
        height: 28px!important;
      }
      .text-btn {
        margin: 0!important;
      }
    }
  }
  .bottom-pagination .el-pagination {
    text-align: right;
    margin-top: 6px;
    margin-bottom: 6px;
  }
  .details-dialog-main{
    table {
      word-break: break-all;
      width: 100%;
      height: 100%;
      border-top: 1px #999 solid;
      border-left: 1px #999 solid;
      th {
        color: #000;
      }
      th, td {
        padding: 12px 0;
        color: #333;
        border-right: 1px #999 solid;
      }
      th {
        border-bottom: 1px #999 solid;
      }
      td {
        border-bottom: 1px #999 solid;
      }
    }
  }
  .logger-dialog-main {
    table {
      word-break: break-all;
      width: 100%;
      // height: calc(100% - 32px);
      height: 100%;
      td {
        padding: 8px 0;
        border-bottom: 1px #f3f4f5 solid;
        text-align: left;
      }
    }
    .text-time {
      color: #409EFF;
    }
    .text-main {
      color: #333;
    }
  }
  .pro-sit-box {
    height: 100vh;
    width: 100vw;
    background: #fff;
    position: absolute;
    top: 0;
    z-index: 999;
  }
}
.protection-dialog-main-estMeeNotice{
  // display: flex;
  justify-content: center;
  .pd-left{
    // width: 50vw;
    // height: calc(66vh - 80px);
    height: 50vh;
    padding: 2px;
  }
  .pd-right{
    // width: 50vw;
    // height: calc(66vh - 80px);
    height: 50vh;
    padding: 2px;
    table{
      width: 100%;
      height: 100%;
      border-top: 1px #000 solid;
      border-left: 1px #000 solid;
      th{
        color: #000;
      }
      th, td{
        padding: 16px 0;
        border-bottom: 1px #000 solid;
        border-right: 1px #000 solid;
      }
    }
  }
}
</style>
